<template>
  <div class="dropdown dropleft">
    <button
        class="btn btn-primary dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        @click="toggleDropdown"
        :aria-expanded="isOpen.toString()">
      Aktion
    </button>
    <ul v-show="isOpen"
        class="dropdown-menu"
        :aria-labelledby="'dropdownMenuButton'">

      <!--- ADMIN --->
      <template v-if="userRole === 'ROLE_ADMIN'">

        <template v-if="holiday.status === 'pending'">
          <!-- Regular holiday -->
          <div v-if="holiday.type === 'regular'">
            <!-- Approve as admin -->
            <a class="dropdown-item" @click="regularHolidayApprove(holiday.id, 'admin')">
              {{ approveAsAdminLabel }}
            </a>
            <!-- Approve as coordinator -->
            <a v-if="holiday.coordinatorApprove == null" class="dropdown-item"
               @click="regularHolidayApprove(holiday.id, 'coordinator')">
              {{ approveAsCoordinatorLabel }}
            </a>
          </div>

          <!-- Special leave -->
          <div v-if="holiday.type === 'special_leave'">
            <!-- Approve as admin -->
            <a class="dropdown-item"
               @click="specialLeaveApprove(holiday.id, 'admin')">
              {{ approveAsAdminLabel }}
            </a>
            <!-- Approve as coordinator -->
            <a v-if="holiday.coordinatorApprove == null" class="dropdown-item"
               @click="specialLeaveApprove(holiday.id, 'coordinator')">
              {{ approveAsCoordinatorLabel }}
            </a>
          </div>

          <!-- Parental leave -->
          <div v-if="holiday.type === 'parental_leave'">
            <!-- Approve as admin -->
            <a class="dropdown-item"
               @click="parentalLeaveApprove(holiday.id, 'admin')">
              {{ approveAsAdminLabel }}
            </a>
            <!-- Approve as coordinator -->
            <a v-if="holiday.coordinatorApprove == null" class="dropdown-item"
               @click="parentalLeaveApprove(holiday.id, 'coordinator')">
              {{ approveAsCoordinatorLabel }}
            </a>
          </div>
        </template>

        <!--- Admin can decline even if status is approved  !!! --->
        <a v-if="holiday.status !== 'declined'"
           class="dropdown-item" @click="declineRequestModal(holiday.id)">
          Ablehnen
        </a>
      </template>


      <!--- HR(PERSONAL) AND COORDINATOR(SITE MANAGER) LOGIC --->
      <template v-if="userRole === 'ROLE_PERSONAL' || userRole === 'ROLE_HEAD_OF_HR'">

        <!--- HR(PERSONAL) --->
        <template v-if="holiday.status === 'pending' && holiday.hrApprove === null">
          <div v-if="holiday.type === 'regular'">
            <a class="dropdown-item" @click="regularHolidayApprove(holiday.id, 'hr')">
              {{ approveLabel }}
            </a>
          </div>
          <div v-if="holiday.type === 'special_leave'">
            <a class="dropdown-item" @click="specialLeaveApprove(holiday.id, 'hr')">
              {{ approveLabel }}
            </a>
          </div>
          <div v-if="holiday.type === 'parental_leave'">
            <a class="dropdown-item" @click="parentalLeaveApprove(holiday.id, 'hr')">
              {{ approveLabel }}
            </a>
          </div>
        </template>

        <!--  HR(PERSONAL) IS AT THE SAME TIME AND COORDINATOR (SITE MANAGER) LOGIC -->
        <template v-if="holiday.user?.coordinator?.id === piniaCurrentUser.id && holiday.coordinatorApprove === null">
          <div v-if="holiday.type === 'regular'">
            <a class="dropdown-item" @click="regularHolidayApprove(holiday.id, 'coordinator')">
              {{ approveAsCoordinatorLabel }}
            </a>
          </div>
          <div v-if="holiday.type === 'special_leave'">
            <a class="dropdown-item" @click="specialLeaveApprove(holiday.id, 'coordinator')">
              {{ approveAsCoordinatorLabel }}
            </a>
          </div>
          <div v-if="holiday.type === 'parental_leave'">
            <a class="dropdown-item" @click="parentalLeaveApprove(holiday.id, 'coordinator')">
              {{ approveAsCoordinatorLabel }}
            </a>
          </div>
        </template>


        <!--- HR can decline even if status is approved  !!! --->
        <a v-if="holiday.status !== 'declined'"
           class="dropdown-item" @click="declineRequestModal(holiday.id)">
          Ablehnen
        </a>
      </template>


      <!--- COORDINATOR(SITE MANAGER) --->
      <template
          v-if="
          userRole === 'ROLE_SITE_MANAGER' ||
          userRole === 'ROLE_HEAD_OF_AMDL' ||
          userRole === 'ROLE_HEAD_OF_MARKETING' ||
          userRole === 'ROLE_HEAD_OF_OCCUPATIONAL_THERAPY' ||
          userRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES'">
        <div v-if="holiday.status === 'pending'  && holiday.coordinatorApprove == null">
          <div v-if="holiday.type === 'regular'">
            <a class="dropdown-item" @click="regularHolidayApprove(holiday.id, 'coordinator')">
              {{ approveAsCoordinatorLabel }}
            </a>
          </div>
          <div v-if="holiday.type === 'special_leave'">
            <a class="dropdown-item" @click="specialLeaveApprove(holiday.id, 'coordinator')">
              {{ approveAsCoordinatorLabel }}
            </a>
          </div>
          <div v-if="holiday.type === 'parental_leave'">
            <a class="dropdown-item" @click="parentalLeaveApprove(holiday.id, 'coordinator')">
              {{ approveAsCoordinatorLabel }}
            </a>
          </div>

          <!--- Coordinator can decline only if status is pending  !!! --->
          <a class="dropdown-item" @click="declineRequestModal(holiday.id)">Ablehnen</a>
        </div>
      </template>

      <li><a class="dropdown-item" href="#" @click="showHolidayDetailsModal()">Einzelheiten</a></li>
      <li><a class="dropdown-item" href="#" @click="showHolidaysInRangeModal()">Urlaubsüberschneidungen</a></li>
    </ul>
  </div>
</template>

<script setup>
import { piniaUserStore } from '@/store/piniaUserStore';
import { computed, defineEmits, defineProps } from 'vue';

const piniaUserState   = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  userRole: {
    type: String,
    required: true,
  },
  holiday: {
    type: Object,
    required: true,
  },
  approveAsAdminLabel: {
    type: String,
    required: true,
  },
  approveAsCoordinatorLabel: {
    type: String,
    required: true,
  },
  approveLabel: {
    type: String,
    required: true,
  },
});

const emit = defineEmits([
  'toggle',
  'showHolidaysInRangeModal',
  'showHolidayDetailsModal',
  'regularHolidayApprove',
  'specialLeaveApprove',
  'parentalLeaveApprove',
  'declineRequest',
]);

const toggleDropdown = () => {
  emit('toggle');
};

function regularHolidayApprove(holidayId, approveBy) {
  emit('regularHolidayApprove', holidayId, approveBy);
}

function specialLeaveApprove(holidayId, approveBy) {
  emit('specialLeaveApprove', holidayId, approveBy);
}

function parentalLeaveApprove(holidayId, approveBy) {
  emit('parentalLeaveApprove', holidayId, approveBy);
}

function declineRequestModal(holidayId) {
  emit('declineRequest', holidayId);
}

function showHolidaysInRangeModal() {
  emit('showHolidaysInRangeModal');
}

function showHolidayDetailsModal() {
  emit('showHolidayDetailsModal');
}
</script>

<style scoped>
.dropdown {
  width: 100%; /* Ensure the dropdown takes up available space */
}

.dropdown-menu {
  font-size: 14px;
  max-width: 250px;
  max-height: 200px;
  overflow-y: auto;
  position: absolute; /* Ensures it's positioned relative to the parent */
  z-index: 5000; /* Make sure it appears above other elements */
}

.dropdown-menu[style] {
  display: block;
}

.dropdown-item {
  word-wrap: break-word; /* Ensure long words break if needed */
}
</style>
